import type { TagColor } from "@/components/ui/tag";
import { deadlineTagColorMap, projectTagColorMap, workflowTagColorMap } from "@/constants";
import type { DeadlineStatus, DeadlineSummaryStatus, ProjectStatus, WorkflowStatus } from "@/types";

export const homeDeadlineTagColorMap: Record<DeadlineStatus, TagColor> = deadlineTagColorMap;

export const homeDeadlineSummaryColorMap: Record<DeadlineSummaryStatus, TagColor> = {
  ...deadlineTagColorMap,
  completed: "Primary",
};

export const homeWorkflowTagColorMap: Record<WorkflowStatus, TagColor> = workflowTagColorMap;

export const homeProjectStatusTagColorMap: Record<ProjectStatus, TagColor> = projectTagColorMap;

export const homeTagSolidColorClassMap: Record<TagColor, string> = {
  Primary: "bg-primary-500",
  Secondary: "bg-accent-600",
  Neutral: "bg-neutral-600",
  Purple: "bg-[#7A08ED]",
  Info: "bg-[#3E87D0]",
  "Info Dark": "bg-[#1C4E88]",
  Success: "bg-success-500",
  Warning: "bg-[#EAAF0B]",
  Danger: "bg-danger-600",
};

export function getHomeWorkflowChartColorClass(status: WorkflowStatus) {
  if (status === "approved") {
    return "bg-success-600";
  }

  return homeTagSolidColorClassMap[homeWorkflowTagColorMap[status]];
}
